"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHfilterSizeRangeMultiplied = exports.defaultHfilterSizeRangeReal = exports.defaultHfilterPriceRangeMultipliedRent = exports.defaultHfilterPriceRangeRealRent = exports.defaultHfilterPriceRangeMultipliedSale = exports.defaultHfilterPriceRangeRealSale = void 0;
exports.defaultHfilterPriceRangeRealSale = [0, 1, 15, 21, 26, 30, 34, 35];
exports.defaultHfilterPriceRangeMultipliedSale = [0, 6, 20, 50, 100, 200, 400, -1];
exports.defaultHfilterPriceRangeRealRent = [0, 1, 17, 27, 32, 33];
exports.defaultHfilterPriceRangeMultipliedRent = [0, 20, 100, 200, 450, -1];
exports.defaultHfilterSizeRangeReal = [0, 1, 8, 13, 18, 19];
exports.defaultHfilterSizeRangeMultiplied = [0, 300, 1000, 2000, 4500, -1];
